import { useState } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { QcFailureRow, QcDashboard } from "@/lib/manufacturing/qcDashboardClient";
import { QcDashboardFailureStats } from "./QcDashboardFailureStats";
import { QcDashboardFailureTable } from "./QcDashboardFailureTable";
import { QcDashboardFold } from "./QcDashboardFold";

function chosenClass(active: boolean): string {
  return active
    ? "rounded-lg bg-gray-900 px-3 py-1.5 text-sm font-semibold text-white dark:bg-zinc-100 dark:text-zinc-900"
    : ghostBtnClass;
}

export function QcDashboardFailures({
  rows,
  dashboard,
  onPage,
  onDeleted,
}: {
  rows: QcFailureRow[];
  dashboard: QcDashboard;
  onPage: (page: number) => void;
  onDeleted: () => void;
}) {
  const [view, setView] = useState<"table" | "stats">("table");
  return (
    <QcDashboardFold title="Failures" defaultOpen>
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="Failure view">
        <button type="button" role="tab" aria-selected={view === "table"} className={chosenClass(view === "table")} onClick={() => setView("table")}>
          Table
        </button>
        <button type="button" role="tab" aria-selected={view === "stats"} className={chosenClass(view === "stats")} onClick={() => setView("stats")}>
          Statistics
        </button>
      </div>
      {view === "table" ? (
        <QcDashboardFailureTable rows={rows} dashboard={dashboard} onPage={onPage} onDeleted={onDeleted} />
      ) : (
        <QcDashboardFailureStats dashboard={dashboard} />
      )}
    </QcDashboardFold>
  );
}
